import $ from 'jquery';

function enableTooltips() {
  $('[data-toggle="tooltip"]').tooltip();
}

export default enableTooltips;
